<template>
  <v-list v-if="selected_company" two-line class="border-grey-all">
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title>{{
          selected_company.card_brand.toUpperCase()
        }}</v-list-tile-title>
        <v-list-tile-sub-title class="py-1"
          >●●●●●●●●{{ selected_company.card_last_four }}</v-list-tile-sub-title
        >
        <v-list-tile-sub-title
          ><b>Default!</b
          ><span>
            Future payments will use this payment method.</span
          ></v-list-tile-sub-title
        >
      </v-list-tile-content>
      <v-list-tile-action style="min-width: 20px !important">
        <v-radio-group
          v-if="show_selected"
          :mandatory="true"
          v-model="is_selected"
          class="ma-0 pa-0"
        >
          <v-radio
            style="width: 0px !important"
            color="primary"
            :value="true"
            :key="'123'"
            class="ma-0 pa-0"
          ></v-radio>
        </v-radio-group>
        <v-btn
          v-if="canEdit"
          :disabled="disabled"
          color="secondary"
          depressed
          small
          class="mx-0 px-0"
          @click="$emit('onEdit')"
          >Update</v-btn
        >
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ExistingPaymentMethod",
  props: {
    is_selected: {
      type: Boolean,
      default: true,
    },
    show_selected: { type: Boolean, default: true },
    canEdit: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
    }),
  },
};
</script>

<style>
</style>
